import Login from '../components/Login'
import About from '../components/pages/About'
import NotFound from '../components/pages/NotFound'

import routingRules from './routingRules'
import routes from './routes'

export default [
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/',
    component: {
      created() {
        this.$router.replace(routingRules.currentUserHomeRoute());
      },
      render() {}
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    component: About,
    name: 'about',
    meta: {
      title: 'About',
      icon: 'fa fa-question'
    }
  },
  ...routes
]



// WEBPACK FOOTER //
// ./src/router/allRoutes.js